import { useTranslation } from 'react-i18next'
import { Checkbox, Spinner } from '@platform/ui'
import { FilterType, IFilter } from './types'

export type FilterOption<T extends string> = {
  label: string
  value: T
}

type Props<T extends string> = {
  filters: IFilter
  filterType: FilterType
  options: FilterOption<T>[]
  onChange: (filterType: FilterType, value: T) => void
  isLoading?: boolean
}

export const CourseFilterCheckboxGroup = <T extends string>({
  filterType,
  options,
  filters,
  onChange,
  isLoading,
}: Props<T>) => {
  const { t, i18n } = useTranslation()

  return (
    <>
      {isLoading && <Spinner />}
      {!isLoading &&
        options.map((option) => (
          <Checkbox
            key={option.value}
            checked={(filters[filterType] as string[]).includes(option.value)}
            onChange={() => onChange(filterType, option.value)}
            testId={`course-filter-${option.value}`}
          >
            {i18n.exists(option.label) ? t(option.label) : option.label}
          </Checkbox>
        ))}
    </>
  )
}
